import { z } from './utils/zod.js';
import { dataResponse } from './utils/response-templates.js';
import { ALLOWANCE_PERIODS, planCodeSchema, planIntervalSchema, usageMeterSchema } from './pricing-catalogue.js';
const subscriptionMetaDataSchema = z.object({
    programId: z.string().optional(),
    refCode: z.string().optional(),
    isNewVisit: z.boolean().optional(),
});
const meterAllowanceSchema = z.object({
    included: z.number().int(),
    period: z.enum(ALLOWANCE_PERIODS),
    overageCents: z.number().int(),
});
// A null meter is unlimited while the others are capped (an ENTERPRISE override on some meters only).
const nullableMeterAllowanceSchema = meterAllowanceSchema.nullable().openapi({ description: 'null = unlimited' });
export const meterAllowancesSchema = z.object({
    AES_SIGNATURE: nullableMeterAllowanceSchema,
    QES_SIGNATURE: nullableMeterAllowanceSchema,
    SMS_OTP: nullableMeterAllowanceSchema,
    EDELIVERY_IDENTITY: nullableMeterAllowanceSchema,
});
export const subscriptionOverviewSchema = z.object({
    planCode: planCodeSchema,
    planInterval: planIntervalSchema.nullable(),
    pendingPlanInterval: planIntervalSchema.nullable(),
    isExempt: z.boolean(),
    status: z.string().nullable().openapi({ description: 'Stripe subscription status' }),
    cancelAt: z.string().datetime().nullable(),
    maxUsers: z.number().int().nullable().openapi({ description: 'null = unlimited' }),
    allowances: meterAllowancesSchema.nullable().openapi({ description: 'null = unlimited, nothing is billed' }),
    basePriceCents: z.number().int(),
    currentPeriodStart: z.string().datetime(),
    currentPeriodEnd: z.string().datetime(),
    payAsYouGo: z.boolean(),
});
export const subscriptionOverviewResponseSchema = dataResponse(subscriptionOverviewSchema);
export const meterUsageSchema = z.object({
    meter: usageMeterSchema,
    used: z.number().int(),
    included: z.number().int().nullable().openapi({ description: 'null = unlimited' }),
    billable: z.number().int(),
    periodStart: z.string().datetime().nullable().openapi({ description: 'null for lifetime allowances' }),
    periodEnd: z.string().datetime().nullable(),
    overageCents: z.number().int().nullable(),
});
export const subscriptionUsageResponseSchema = dataResponse(z.array(meterUsageSchema));
export const startSubscriptionRequestSchema = z.object({
    interval: planIntervalSchema,
    metaData: subscriptionMetaDataSchema.optional(),
    withdrawalConsent: z.literal(true).optional(),
});
export const startSubscriptionResponseSchema = dataResponse(z.object({
    subscriptionId: z.string(),
    status: z.string(),
    clientSecret: z.string().nullable().openapi({
        description: 'Confirm the first payment with this secret; null when no payment is due',
    }),
}));
export const changeIntervalRequestSchema = z.object({
    interval: planIntervalSchema,
});
